import { defineStore } from 'pinia'
import Storage from '@/utils/storage'
import { setLocale as setAppLocale } from '@/utils/locale'

// 用户状态管理
export const useUserStore = defineStore('user', {
  state: () => ({
    token: Storage.get('token') || '',
    userInfo: Storage.get('userInfo') || null,
    locale: Storage.get('locale') || 'zh-CN'
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    username: (state) => state.userInfo?.username || '',
    selectedOrg: (state) => state.userInfo?.selectedOrg || null,
    getLocale: (state) => state.locale
  },

  actions: {
    // 登录
    login(token, userInfo) {
      this.token = token
      this.userInfo = userInfo
      Storage.set('token', token)
      Storage.set('userInfo', userInfo)
    },

    // 登出
    logout() {
      this.token = ''
      this.userInfo = null
      Storage.remove('token')
      Storage.remove('userInfo')
      Storage.remove('editCourse')
      Storage.remove('username')
      Storage.remove('userId')
      Storage.remove('childrenId')
      Storage.remove('satoken')
      Storage.remove('orgId')
      Storage.remove('selectedOrg')
      Storage.remove('equipment')
      Storage.remove('userRole')
    },

    // 更新用户信息
    updateUserInfo(userInfo) {
      this.userInfo = userInfo
      Storage.set('userInfo', userInfo)
    },

    // 切换语言
    setLocale(locale) {
      this.locale = locale
      Storage.set('locale', locale)
      setAppLocale(locale)
    }
  }
})
